import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import TextboxField from "../../../components/Fields/TextboxField";
import { FormConfig } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { UserPopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface ChangePasswordModel {
    id: number
    username: string
    password: string
    newPassword1: string
    newPassword2: string
}

interface IProps {
    show: boolean
    onHide: () => void
    userId: number
    username: string
}

const UserChangePasswordPopup: React.FC<IProps> = ({ show, onHide, userId, username }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<ChangePasswordModel>>({ isSuccesful: true, messages: [], data: undefined });
    const [formData, setFormData] = useState<ChangePasswordModel>({
        id: userId,
        username: username,
        password: '',
        newPassword1: '',
        newPassword2: ''
    });

    const { handleResult, handleException } = useNotifications();

    function submit() {
        if (formData) {
            DataService
                .create<ChangePasswordModel>(`api/v1/Users/changepassword`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        if (onHide)
                            onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    function onFieldChanged(name: string, value: string): void {
        formData[name] = value;
        setFormData(formData);
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'password', label: 'Old password', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
            { name: 'newPassword1', label: 'New password', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
            { name: 'newPassword2', label: 'Repeat password', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Change password'} >
            <Popup.Body>
                <TextboxField {...getFieldProps('password')} />
                <TextboxField {...getFieldProps('newPassword1')} />
                <TextboxField {...getFieldProps('newPassword2')} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton text='Change' {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default UserChangePasswordPopup;